import { render, staticRenderFns } from "./roles-lista.vue?vue&type=template&id=453d773d&"
import script from "./roles-lista.vue?vue&type=script&lang=js&"
export * from "./roles-lista.vue?vue&type=script&lang=js&"
import style0 from "./roles-lista.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports